// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopTicketFareControllerGetCustomerTicketFaresData } from './EshopTicketFareControllerGetCustomerTicketFaresData.gen';
import type { EshopTicketFareControllerGetCustomerTicketFaresErrors } from './EshopTicketFareControllerGetCustomerTicketFaresErrors.gen';
import type { EshopTicketFareControllerGetCustomerTicketFaresResponses } from './EshopTicketFareControllerGetCustomerTicketFaresResponses.gen';
import type { EshopTicketFareControllerGetTicketByIdData } from './EshopTicketFareControllerGetTicketByIdData.gen';
import type { EshopTicketFareControllerGetTicketByIdErrors } from './EshopTicketFareControllerGetTicketByIdErrors.gen';
import type { EshopTicketFareControllerGetTicketByIdResponses } from './EshopTicketFareControllerGetTicketByIdResponses.gen';
import type { Options } from './Options.gen';

export class EshopTicketFareController {
    /**
     * Get ticket fare list.
     */
    public static getCustomerTicketFares<ThrowOnError extends boolean = false>(options?: Options<EshopTicketFareControllerGetCustomerTicketFaresData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopTicketFareControllerGetCustomerTicketFaresResponses, EshopTicketFareControllerGetCustomerTicketFaresErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/ticket-fares',
            ...options
        });
    }
    
    /**
     * Get ticket by ID.
     */
    public static getTicketById<ThrowOnError extends boolean = false>(options: Options<EshopTicketFareControllerGetTicketByIdData, ThrowOnError>) {
        return (options.client ?? client).get<EshopTicketFareControllerGetTicketByIdResponses, EshopTicketFareControllerGetTicketByIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/ticket-fares/{id}',
            ...options
        });
    }
}
